import React, { useEffect, useState, useCallback } from 'react';

import { Link } from 'react-router';

import { Subscribe } from 'unstated';

import { ProfileContainer } from './containers/profile-container';

import { Form, Field } from 'react-final-form';

import { FORM_ERROR } from 'final-form';

import { withRouter } from 'react-router';

import { TextInput } from '../components/ui/text-input';
import { FormErrors } from '../components/ui/form-errors';

import { required, maxLength, composeField } from '../lib/form-validators';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PublicPage from './public-page';

const Impersonate = (props) => {
  // The link carries the token in the fragment, which no server or Referer sees.
  const [token, setToken] = useState(
    new URLSearchParams(props.location.hash.slice(1)).get('token') || undefined
  );
  const [profileContainer, setProfileContainer] = useState(null);

  const onSubmit = useCallback(
    async ({ token }) => {
      try {
        await profileContainer.impersonate(token);
        // A new page, so no container keeps what it read for whoever was signed in before.
        window.location.replace('/account');
      } catch (e) {
        console.log(e);
        return { [FORM_ERROR]: 'Impersonation failed' };
      }
    },
    [profileContainer]
  );

  useEffect(() => {
    if (!profileContainer) {
      return;
    }
    if (token) {
      props.router.replace({
        pathname: props.location.pathname
      });
      onSubmit({ token });
    }
  }, [token, profileContainer]);

  return (
    <>
      <Subscribe to={[ProfileContainer]}>
        {(profileContainer) => {
          setProfileContainer(profileContainer);
          return <div />;
        }}
      </Subscribe>
      <PublicPage>
        <div className="content text-center align-items-center">
          <Form
            onSubmit={onSubmit}
            initialValues={{ token }}
            render={({
              handleSubmit,
              submitting,
              submitError,
              dirtySinceLastSubmit
            }) => (
              <form onSubmit={handleSubmit}>
                <Field
                  name="token"
                  inputClass="dc-login_input"
                  validate={composeField(required, maxLength(128))}
                  render={TextInput}
                  placeholder="TOKEN"
                  prependValue={
                    <div className="dc-login_icon">
                      <FontAwesomeIcon
                        icon={['fas', 'key']}
                        size="sm"
                        color="#69717a"
                      />
                    </div>
                  }
                />

                <FormErrors
                  submitError={submitError}
                  dirtySinceLastSubmit={dirtySinceLastSubmit}
                />

                <hr className="mh-3 w-100" />
                <div className="mt-3 w-100">
                  <button
                    type="submit"
                    className="btn btn-primary btn-xl w-100 text-uppercase"
                    disabled={submitting}
                  >
                    IMPERSONATE
                  </button>
                </div>
              </form>
            )}
          />
        </div>
        <div className="footer text-center mt-5">
          <Link className="text-uppercase" to="/">
            Login
          </Link>
        </div>
      </PublicPage>
    </>
  );
};

export default withRouter(Impersonate);
